import { initialWindowType } from '@/hooks/media';
import { Modal } from '@bfe/moly';
import Image from 'next/image';
import styles from './index.module.scss';
import { UNSUPPORTED_ICON } from '@/constants';
import { Button } from '@/components';
import { useFm } from '@web3/base-hooks';

interface Props {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UnsupportedCloudWallet = ({ visible, onClose, onConfirm }: Props) => {
  const { isMobile } = initialWindowType;
  const fm = useFm();

  const Footer = (
    <div className={styles.footer}>
      <Button
        variant="primary"
        size={isMobile ? 'small' : 'middle'}
        onClick={onConfirm}
      >
        {fm('aidolConnectWeb3Wallet')}
      </Button>
    </div>
  );

  return (
    <Modal
      modal={false}
      className={styles.modal}
      isMobile={isMobile}
      direction={!isMobile ? 'center' : 'bottom'}
      cancelText={false}
      onCancel={() => {
        onClose?.();
      }}
      open={visible}
      onOpenAutoFocus={(e) => e.preventDefault()}
      // contextWrapper={styles.contextWrapper}
      footer={Footer}
      footerWrapper={styles.footerWrapper}
    >
      <div className={styles.content}>
        <Image
          className={styles.mainIcon}
          loader={({ src }) => src}
          src={UNSUPPORTED_ICON}
          width={72}
          height={72}
          alt=""
        />
        <h1 className={styles.title}>{fm('unsupportedCloudWalletTitle')}</h1>
        <ul className={styles.mainText}>
          <li>{fm('unsupportedCloudWalletContent')}</li>
        </ul>
      </div>
    </Modal>
  );
};

export default UnsupportedCloudWallet;
